import React, { FC, useContext } from 'react';
import { TeamID } from '../../../scripts/models/common';
import { DataContext } from '../../context/dataLoader/DataLoader';
import ModificationsDisplay from './ModificationsDisplay';

import './TeamModificationsDisplay.scss';

interface IProps {
    teamID?: TeamID
}

const TeamModificationsDisplay: FC<IProps> = (props) => {
    const { teamID } = props;

    const { teamCollections, playerCollections } = useContext(DataContext)


    if (!teamID) {
        return <div className='TeamModsDisplay'>Pick a team to view.</div>
    }

    if (!teamCollections || !playerCollections) {
        return <div className='TeamModsDisplay'>Loading...</div>
    }

    const team = teamCollections.teamsById[teamID];

    const teamMods = team.modifications;

    const modifiedPlayers = playerCollections.playersByTeam[teamID].ANY.filter(player => player.modifications.length > 0)
    const hasModifiedPlayers = modifiedPlayers.length > 0;

    return <div className='TeamModsDisplay'>
        <div className="TeamMods">
            <div>
                <span className='name'>{team.name}</span>
            </div>
            <ModificationsDisplay modifications={teamMods} />
        </div>
        <div className="spacer" />
        <div className="PlayerMods">
            {
                hasModifiedPlayers ? (
                    modifiedPlayers.map((player, idx) => (
                        <div key={idx}>
                            <div>
                                <span className='name'>{player.name}</span>
                            </div>
                            <ModificationsDisplay modifications={player.modifications} />

                        </div>

                    ))
                ) : (
                    <div className='subtle'>No modified players...</div>
                )
            }
        </div>
    </div>
}

export default TeamModificationsDisplay;